export const MAX_BAR_WIDTH = 28;
export const BAR_MARGIN = 8;
export const MIN_GROUP_PADDING = 24;
